<template>
  <div class="group group--sidebar group--df-column pab2">
    <ui-auth
      :id="registerForm"
      :success="success"
    />
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Ui
import UiAuth from 'components/Auth';

// Mixins
import MixinIntakeProgress from 'components/IntakeProgress';

// Export
export default {
  name: 'view-register',

  // Components
  components: {
    UiAuth,
  },

  // Mixins
  mixins: [
    MixinIntakeProgress,
  ],

  // Computed
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters('provider', ['selectedSlot', 'selectedAppointmentType']),

    ...mapGetters('appointment', [
      'appointments',
      'f2fAppointment',
    ]),

    registerForm() {
      return localStorage.getItem('updateUser') ? 'registerbooking' : 'register';
    },
  },


  // Methods
  methods: {
    ...mapActions('appointment', [
      'requestAppointmentUpcoming',
    ]),

    success() {
      localStorage.removeItem('startIntakeTimeStamp');
    },
  },

  // Lifecycles
  // beforeRouteEnter (to, from, next) {
  //   localStorage.removeItem('timezone');
  //   if ( !from || !from.name ) {
  //     next({ name: 'home' });
  //   } else {
  //     next();
  //   }
  // },

};
</script>



// WEBPACK FOOTER //
// Register.vue?4d4f890e